import { render, staticRenderFns } from "./HeroSliderAndAnimation.vue?vue&type=template&id=16045675&scoped=true"
import script from "./HeroSliderAndAnimation.vue?vue&type=script&lang=js"
export * from "./HeroSliderAndAnimation.vue?vue&type=script&lang=js"
import style0 from "./HeroSliderAndAnimation.vue?vue&type=style&index=0&id=16045675&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16045675",
  null
  
)

export default component.exports